import { render, staticRenderFns } from "./Immersive.vue?vue&type=template&id=f11f6190&"
import script from "./Immersive.vue?vue&type=script&lang=js&"
export * from "./Immersive.vue?vue&type=script&lang=js&"
import style0 from "./Immersive.vue?vue&type=style&index=0&id=f11f6190&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports